export default __webpack_public_path__ + "static/media/Lightsaber Obi-Wan ANH - Img - Wip 4_08.a34428d3.jpg";